<template>
  <div class="money-back">
    <CNuxtImg
      class="money-back__image"
      src="img_moneyback.webp"
      alt="money back"
      min-height="113px"
      localize
    />

    <div class="money-back__text-block">
      <h2 class="money-back__title title-26-600 text-center">
        {{ $t('lp_v7_money_back_title') }}
      </h2>
      <p class="money-back__subtitle paragraph-16-500 text-center">
        {{ $t('lp_v7_money_back_subtitle') }}
      </p>
      <span
        class="money-back__text paragraph_14-400"
        v-html="$t('lp_v7_money_back_body', ['contact@kegel-plan.com'])"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.money-back {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: linear-gradient(180deg, rgba(241, 243, 249, 0.00) 0%, #F1F3F9 23.44%);
  position: relative;
  padding-top: 88px;

  @media (min-width: 600px ) {
    padding-top: 176px;
  }

  &__image {
    position: absolute;
    top: -52px;
    width: 100%;
  }

  &__text-block {
    display: flex;
    flex-direction: column;
    padding: 0 32px 32px 32px;
  }

  &__title {
    font-weight: 700 !important;
  }

  &__subtitle {
    line-height: 21px;
    font-family: $primary-fonts;
  }

  &__text {
    margin-top: 24px;
    opacity: 0.8;
  }
}
</style>

<style lang="scss">
.guarantee-link {
  color: rgba(87, 115, 214, 0.80);
  text-decoration: underline;
}
</style>
